import PropTypes from 'prop-types';

export default PropTypes.oneOf(['GBP', 'EUR', 'USD']);
